import { Tooltip } from "@mui/material";
import React from "react";
import { MdAttachFile, MdDownload } from "react-icons/md";

const SupportingInfo = ({ item }) => {
  const tableHeaders = [
    { name: "Category" },
    { name: "Code" },
    { name: "Timing" },
    { name: "Value" },
  ];
  function downloadBase64File(base64Data, fileName, fileType) {
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: fileType });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    URL.revokeObjectURL(url);
  }

  return (
    // <div class="pre_auth_detail_section">
    //   <div class="pre_auth-detail_section_head">
    //     <span>Supporting Info</span>
    //   </div>
    //   <div class="pre_auth-detail_section_cont">
    //     <div class="pre_auth_communication_table">
    //       <table>
    //         <thead>
    //           <tr>
    //             {tableHeaders.map((el, index) => {
    //               return <th key={"tableHeaders_" + index}>{el.name}</th>;
    //             })}
    //           </tr>
    //         </thead>
    //         <tbody>
    //           {item?.getClaimTransaction?.data?.supporting_info?.map((item) => (
    //             <tr key={item.id}>
    //               <td>{item.category}</td>
    //               <td>{item.code}</td>
    //               <td>
    //                 <p>
    //                   {item.start_date} {item.end_date && ` - ${item.end_date}`}
    //                 </p>
    //               </td>
    //               <td>
    //                 {item.category === "attachment" ? (
    //                   <div className="flex gap-2">
    //                     {item?.image_content_type === "image/jpeg" ||
    //                     item?.image_content_type === "image/png" ? (
    //                       <div className="w-20 h-20 my-auto">
    //                         <img
    //                           src={`data:${item?.image_content_type};base64,${item?.image_value}`}
    //                           alt={`${item?.image_title} Image`}
    //                           className="rounded-md"
    //                         />
    //                       </div>
    //                     ) : null}
    //                     <label className="flex gap-2 my-auto">
    //                       {!(
    //                         item?.image_content_type === "image/jpeg" ||
    //                         item?.image_content_type === "image/png"
    //                       ) ? (
    //                         <span className="font-bold text-lg">
    //                           <MdAttachFile />
    //                         </span>
    //                       ) : null}

    //                       {item?.image_title}

    //                       <span
    //                         className="font-bold text-lg my-auto ml-6"
    //                         onClick={() =>
    //                           downloadBase64File(
    //                             item?.image_value,
    //                             item?.image_title,
    //                             item?.image_content_type
    //                           )
    //                         }
    //                       >
    //                         <MdDownload />
    //                       </span>
    //                     </label>
    //                   </div>
    //                 ) : (
    //                   item.value
    //                 )}
    //               </td>
    //             </tr>
    //           ))}
    //         </tbody>
    //       </table>
    //     </div>
    //   </div>
    // </div>

    <div class="eligibility_details_section !p-0 ">
      <div className="eligibility_details_body_cont !p-0 !border-none !shadow-none">
        <div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 !p-0 !border-none !shadow-none">
            {item?.getClaimTransaction?.data?.supporting_info?.map((item) => (
              <div
                className="shadow-md rounded-lg p-3 gap-3 flex flex-col border border-black/20"
                key={item.id}
              >
                <div className="flex justify-between">
                  <dt className="text-sm font-semibold text-gray-600 my-auto">
                    Category
                  </dt>
                  <dd className=" text-sm text-gray-900 text-ellipsis overflow-hidden w-52 text-end capitalize">
                    {item?.category || "___"}
                  </dd>
                </div>

                <div className="flex justify-between">
                  <dt className="text-sm font-semibold text-gray-600 my-auto">
                    Code
                  </dt>
                  <dd className=" text-sm text-gray-900 text-ellipsis overflow-hidden w-52 text-end">
                    {item?.code || "___"}
                  </dd>
                </div>

                <div className="flex justify-between">
                  <dt className="text-sm font-semibold text-gray-600 my-auto">
                    Timming
                  </dt>
                  <dd className=" text-sm text-gray-900 text-ellipsis overflow-hidden w-52 text-end">
                    {item?.start_date}{" "}
                    {(item?.end_date && ` - ${item?.end_date}`) || "___"}
                  </dd>
                </div>

                <div className="flex justify-between">
                  <dt className="text-sm font-semibold text-gray-600 my-auto">
                    Value
                  </dt>
                  <dd className=" text-sm text-gray-900 text-ellipsis overflow-hidden w-52 text-end capitalize">
                    {item.category === "attachment" ? (
                      <div className="flex gap-2">
                        {item?.image_content_type === "image/jpeg" ||
                        item?.image_content_type === "image/png" ? (
                          <div className="w-12 h-12 my-auto">
                            <img
                              src={`data:${item?.image_content_type};base64,${item?.image_value}`}
                              alt={`${item?.image_title} Image`}
                              className="rounded-md"
                            />
                          </div>
                        ) : null}
                        <Tooltip title="Download Attachment">
                          <label
                            className="flex gap-2 my-auto cursor-pointer"
                            onClick={() =>
                              downloadBase64File(
                                item?.image_value,
                                item?.image_title,
                                item?.image_content_type
                              )
                            }
                          >
                            {!(
                              item?.image_content_type === "image/jpeg" ||
                              item?.image_content_type === "image/png"
                            ) ? (
                              <span className="font-bold text-lg">
                                <MdAttachFile />
                              </span>
                            ) : null}

                            {item?.image_title}
                          </label>
                        </Tooltip>
                      </div>
                    ) : item?.value?.length > 100 ? (
                      <Tooltip title={item?.value}>
                        <span>{item?.value.slice(0, 100)}...</span>
                      </Tooltip>
                    ) : (
                      item?.value
                    )}
                  </dd>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
  return (
    <div>
      <table className="min-w-full divide-y divide-gray-300">
        <thead className="bg-cyan-600">
          <tr>
            {tableHeaders.map((el, index) => {
              return (
                <th
                  scope="col"
                  className="whitespace-nowrap py-1 pl-4 pr-3 text-left text-sm font-semibold text-white sm:pl-2"
                  key={"tableHeaders_" + index}
                >
                  {el.name}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200 bg-white">
          {item?.getClaimTransaction?.data?.supporting_info?.map((item) => (
            <tr key={item.id} className="cursor-pointer py-2">
              <td className="whitespace-nowrap px-2 py-2 text-sm text-gray-900">
                {item.category}
              </td>
              <td className="whitespace-nowrap px-2 py-2 text-sm text-gray-900">
                {item.code}
              </td>
              <td className="whitespace-nowrap px-2 py-2 text-sm text-gray-900">
                <p>
                  {item.start_date} {item.end_date && ` - ${item.end_date}`}
                </p>
              </td>
              <td className="whitespace-nowrap px-2 py-2 text-sm text-gray-900 ">
                {item.value}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
export default SupportingInfo;
